import _ from 'lodash';
import { DEFAULT_TABLE_COLUMN_PROPERTIES, } from '../client-state-type';
export function getValidConditionalFormatting(conditionalFormatting, validColumnIds) {
    if (_.isNil(conditionalFormatting) || _.isNil(conditionalFormatting.rows)) {
        return null;
    }
    const validRows = conditionalFormatting.rows.filter(row => {
        if (_.isNil(row === null || row === void 0 ? void 0 : row.lhsColumnId) ||
            !validColumnIds.includes(row.lhsColumnId)) {
            return false;
        }
        if (!_.isNil(row.rhsColumnId) &&
            !validColumnIds.includes(row.rhsColumnId)) {
            return false;
        }
        return true;
    });
    if (validRows.length === 0) {
        return null;
    }
    return {
        ...conditionalFormatting,
        rows: validRows,
    };
}
function applyTableDisplayOverrides(tableVizProps, displayProperties) {
    if (_.isNil(displayProperties)) {
        return tableVizProps;
    }
    const updatedTableVizProps = { ...tableVizProps };
    if (!_.isNil(displayProperties.tableTheme)) {
        updatedTableVizProps.theme = displayProperties.tableTheme;
    }
    if (!_.isNil(displayProperties.tableContentDensity)) {
        updatedTableVizProps.density = displayProperties.tableContentDensity;
    }
    return updatedTableVizProps;
}
function applyTableColumnOverrides(tableVizProps, columnPropertyOverrides, columns) {
    var _a;
    if (_.isNil(columnPropertyOverrides)) {
        return tableVizProps;
    }
    const validColumnIds = columns.map(col => col.column.id);
    const validColumnPropertyOverrides = columnPropertyOverrides.filter(cp => !_.isNil(cp === null || cp === void 0 ? void 0 : cp.columnId) &&
        validColumnIds.includes(cp.columnId) &&
        !_.isNil(cp.columnProperty));
    const updatedColumnProperties = _.cloneDeep((_a = tableVizProps.columnProperties) !== null && _a !== void 0 ? _a : []);
    validColumnPropertyOverrides.forEach(columnPropertyOverride => {
        var _a, _b;
        const existingPropIndex = updatedColumnProperties.findIndex(cp => (cp === null || cp === void 0 ? void 0 : cp.columnId) === columnPropertyOverride.columnId);
        const validConditionalFormatting = getValidConditionalFormatting((_a = columnPropertyOverride.columnProperty) === null || _a === void 0 ? void 0 : _a.conditionalFormatting, validColumnIds);
        const overrideProperty = columnPropertyOverride.columnProperty;
        const applicableOverrides = _.pickBy({
            isHidden: overrideProperty.isHidden,
            wrapColumnText: overrideProperty.wrapColumnText,
            conditionalFormatting: validConditionalFormatting,
        }, v => !_.isNil(v));
        if (existingPropIndex >= 0) {
            updatedColumnProperties[existingPropIndex].columnProperty = {
                ...DEFAULT_TABLE_COLUMN_PROPERTIES,
                ...(_b = updatedColumnProperties[existingPropIndex]) === null || _b === void 0 ? void 0 : _b.columnProperty,
                ...applicableOverrides,
            };
        }
        else {
            updatedColumnProperties.push({
                __typename: 'TableColumnPropertyMap',
                columnId: columnPropertyOverride.columnId,
                columnProperty: {
                    ...DEFAULT_TABLE_COLUMN_PROPERTIES,
                    ...applicableOverrides,
                },
            });
        }
    });
    return {
        ...tableVizProps,
        columnProperties: updatedColumnProperties,
    };
}
export function applyTableVisualOverrides(vizModel, columns) {
    const vizProps = vizModel.vizProps;
    const visualOverrides = vizModel.visualOverrides;
    if (_.isNil(visualOverrides) || _.isNil(visualOverrides.overrides)) {
        return vizProps;
    }
    const { displayProperties, columnProperties: columnPropertyOverrides, } = visualOverrides.overrides;
    let updatedTableVizProps = _.cloneDeep(vizProps);
    updatedTableVizProps = applyTableDisplayOverrides(updatedTableVizProps, displayProperties);
    updatedTableVizProps = applyTableColumnOverrides(updatedTableVizProps, columnPropertyOverrides, columns);
    return updatedTableVizProps;
}
//# sourceMappingURL=table-overrides-util.js.map